import React, { useContext } from 'react';
import BackdropLoadingContext from '../context/BackdropLoadingContext';

export default function useBackdropLoading() {
  const { showLoading, stopLoading } = useContext(BackdropLoadingContext);

  return { showLoading, stopLoading };
}
